import { ElementRef, NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
import Sortable from 'sortablejs';
import { addCalcInfo } from 'CalculationsApp/ts/state/calc-info.actions';
import { addFundChartCalc, addFundChartCalcs, removeFundChartCalc, setFundChartCalcs, toggleFundChartCalc, } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/calcs/calcs.actions';
import { isLoadingCalcs } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/calcs/calcs.selectors';
import { CalculationsService } from 'CalculationsApp/ts/services/calculations.service';
import { disablePointerEvents, enablePointerEvents } from 'Angular/utils/sortable-utils';
import * as i0 from "@angular/core";
import * as i1 from "@ngrx/store";
import * as i2 from "CalculationsApp/ts/services/calculations.service";
import * as i3 from "../../../../../../../../search/static/search/ts/features/add-button-autocomplete/add-button-autocomplete.component";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i5 from "../../../../../../../../calculations/static/calculations/ts/features/metric-selector-modal/components/multi-metric-selector-modal/multi-metric-selector-modal.component";
import * as i6 from "../../../../../../../../../ycharts/static/ts/features/components/loaders/skeleton-loaders-list/skeleton-loaders-list.component";
import * as i7 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
const _c0 = ["sortableMetricsContainer"];
const _forTrack0 = ($index, $item) => $item.id;
function FundChartMetricsListComponent_Conditional_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-skeleton-loaders-list", 13);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("loading", ctx_r2.isLoading)("numOfSkeletonLoaders", ctx_r2.calcs.length);
} }
function FundChartMetricsListComponent_Conditional_18_For_1_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 15)(1, "div", 16)(2, "label", 17)(3, "input", 18);
    i0.ɵɵlistener("click", function FundChartMetricsListComponent_Conditional_18_For_1_Conditional_1_Template_input_click_3_listener() { i0.ɵɵrestoreView(_r4); const calc_r5 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.toggle(calc_r5)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "span", 19);
    i0.ɵɵelementStart(5, "span", 20);
    i0.ɵɵtext(6);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(7, "div", 21)(8, "div", 22);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(9, "svg", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(10, "div", 24);
    i0.ɵɵlistener("click", function FundChartMetricsListComponent_Conditional_18_For_1_Conditional_1_Template_div_click_10_listener() { i0.ɵɵrestoreView(_r4); const calc_r5 = i0.ɵɵnextContext().$implicit; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.delete(calc_r5)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(11, "svg", 25);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const calc_r5 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("checked", calc_r5.include);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r2.calcInfo[calc_r5.id].label);
} }
function FundChartMetricsListComponent_Conditional_18_For_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14);
    i0.ɵɵconditionalCreate(1, FundChartMetricsListComponent_Conditional_18_For_1_Conditional_1_Template, 12, 2, "div", 15);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const calc_r5 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("id", i0.ɵɵinterpolate(calc_r5.id));
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r2.calcInfo[calc_r5.id] ? 1 : -1);
} }
function FundChartMetricsListComponent_Conditional_18_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵrepeaterCreate(0, FundChartMetricsListComponent_Conditional_18_For_1_Template, 2, 3, "div", 14, _forTrack0);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵrepeater(ctx_r2.calcs);
} }
export class FundChartMetricsListComponent {
    constructor(store, calculationsService, ngZone) {
        this.store = store;
        this.calculationsService = calculationsService;
        this.ngZone = ngZone;
        this.defaultOnly = false;
        this.isFetchingMetrics = false;
        this.isLoading = false;
        this.calcs = [];
        this.calcInfo = {};
        this.updateOrdering = (oldIndex, newIndex) => {
            const metrics = this.calcs.map((calc) => {
                return { ...calc };
            });
            metrics.splice(newIndex, 0, metrics.splice(oldIndex, 1)[0]);
            this.store.dispatch(setFundChartCalcs({ metrics }));
        };
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent.bind(this));
    }
    ngAfterViewInit() {
        this.initializeSortable();
    }
    ngOnDestroy() {
        this.storeSubscription.unsubscribe();
    }
    mapStateToComponent(state) {
        const { fundChart, calcInfo } = state;
        this.validateNextMetrics(calcInfo, fundChart.calcs);
        this.calcInfo = calcInfo;
        this.calcs = fundChart.calcs;
        this.isLoading = isLoadingCalcs(state);
    }
    /**
     * Validate fund chart metrics.
     *
     * @param calcInfo: An object containing information about the metrics.
     * @param calcs: An array containing the state metrics.
     */
    validateNextMetrics(calcInfo, calcs) {
        // Filter duplicates
        const uniqueCalcs = calcs.filter((calc, index, array) => index === array.findIndex((_) => _.id === calc.id));
        // Determine calcs that do not have calcInfo
        const calcsMissingInfo = uniqueCalcs.filter((c) => !calcInfo[c.id]).map((c) => c.id);
        if (calcsMissingInfo.length > 0 && !this.isFetchingMetrics) {
            this.isFetchingMetrics = true;
            this.calculationsService.getCalcInfo(calcsMissingInfo).subscribe((data) => {
                this.store.dispatch(addCalcInfo({ calcInfo: data }));
                const validCalcs = uniqueCalcs.filter((calc) => this.calcInfo[calc.id]);
                this.isFetchingMetrics = false;
                this.store.dispatch(setFundChartCalcs({ metrics: validCalcs }));
            });
        }
        else if (calcsMissingInfo.length === 0) {
            const validCalcs = uniqueCalcs.filter((calc) => this.calcInfo[calc.id]);
            if (calcs.length !== validCalcs.length) {
                this.store.dispatch(setFundChartCalcs({ metrics: validCalcs }));
            }
        }
    }
    toggle(metric) {
        this.store.dispatch(toggleFundChartCalc({ metric }));
    }
    delete(metric) {
        this.store.dispatch(removeFundChartCalc({ metric }));
    }
    add(metric) {
        this.store.dispatch(addCalcInfo({
            calcInfo: {
                [metric.search_id]: {
                    label: metric.name,
                    features_needed: metric.features_needed,
                },
            },
        }));
        this.store.dispatch(addFundChartCalc({ metric: { id: metric.search_id, include: true } }));
    }
    addMetrics(metrics) {
        const mappedCalcInfo = {};
        const mappedMetrics = metrics.map(({ internal_name, label, features_needed }) => {
            mappedCalcInfo[internal_name] = {
                label,
                features_needed,
            };
            return { id: internal_name, include: true };
        });
        this.store.dispatch(addCalcInfo({
            calcInfo: mappedCalcInfo,
        }));
        this.store.dispatch(addFundChartCalcs({ metrics: mappedMetrics }));
    }
    initializeSortable() {
        // For performance reasons we don't want Angular change detection to run while dragging an
        // element around, so we explicitly run SortableJS outside of Angular.
        this.ngZone.runOutsideAngular(() => {
            Sortable.create(this.sortableMetricsContainer.nativeElement, {
                handle: '.btn-reorder-up',
                ghostClass: 'report-module-ghost',
                scroll: false,
                animation: 150,
                onUpdate: (evt) => {
                    // The Sortable library is outside of our Angular context so we need to wrap
                    // our handler in a $apply statement so that we are within a digest cycle.
                    this.ngZone.run(() => {
                        if (evt.oldIndex !== undefined && evt.newIndex !== undefined) {
                            this.updateOrdering(evt.oldIndex, evt.newIndex);
                        }
                    });
                    // This is a workaround for a bug in the Sortable library which can recheck
                    // unchecked items after dragging. There is no entrypoint provided by SortableJS
                    // after it updates the checkbox state, so we need to delay execution.
                    setTimeout(() => {
                        const { children } = evt.target;
                        this.calcs.forEach((calc) => {
                            for (let i = 0; i < children.length; i += 1) {
                                const child = children[i];
                                if (calc.id === child.id) {
                                    const el = child.getElementsByClassName('custom-control-input')[0];
                                    if (el && el.checked !== calc.include) {
                                        el.checked = calc.include;
                                    }
                                }
                            }
                        });
                    });
                },
                onStart: () => {
                    // Prevent pointer-events on btn classes on click in modules-container for tooltip/sortable bug
                    disablePointerEvents(document, 'options-list-item');
                },
                onEnd: () => {
                    enablePointerEvents(document, 'options-list-item');
                },
            });
        });
    }
}
FundChartMetricsListComponent.ɵfac = function FundChartMetricsListComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || FundChartMetricsListComponent)(i0.ɵɵdirectiveInject(i1.Store), i0.ɵɵdirectiveInject(i2.CalculationsService), i0.ɵɵdirectiveInject(i0.NgZone)); };
FundChartMetricsListComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: FundChartMetricsListComponent, selectors: [["ycn-fund-chart-metrics-list"]], viewQuery: function FundChartMetricsListComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sortableMetricsContainer = _t.first);
    } }, inputs: { defaultOnly: "defaultOnly" }, standalone: false, decls: 19, vars: 4, consts: [["multiMetricSelectorModal", ""], ["sortableMetricsContainer", ""], [1, "panel-sidebar-section-header"], [1, "panel-sidebar-section-title", "user-select-none"], [1, "panel-sidebar-section-row"], ["data-test-id", "metrics-search-autocomplete", "searchType", "history_calc", 1, "input-group", 3, "submitHandler", "appendToBody", "defaultOnly"], [1, "divider-vertical"], [1, "panel-sidebar-section-control"], ["data-test-id", "metrics-browse-button", 1, "btn", "btn-secondary", 3, "click"], ["ycnIcon", "", "name", "icon-browse"], ["searchType", "history_calc", 3, "submitModalHandler", "defaultOnly"], [1, "panel-sidebar-section-body"], ["id", "calcs-list", 1, "options-list", "user-select-none"], [3, "loading", "numOfSkeletonLoaders"], ["data-test-id", "metric-list-item", 1, "options-list-item", 3, "id"], [1, "options-list-item-header"], [1, "options-list-item-title"], [1, "custom-control", "custom-checkbox"], ["type", "checkbox", 1, "custom-control-input", 3, "click", "checked"], [1, "custom-control-indicator"], [1, "custom-control-description"], [1, "options-list-item-controls"], ["ycnTooltip", "", "tooltipPlacement", "bottom", "tooltipTitle", "Reorder", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-reorder-up"], ["ycnIcon", "", "name", "icon-reorder-up"], ["ycnTooltip", "", "tooltipTitle", "Remove", 1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-close", 3, "click"], ["ycnIcon", "", "name", "icon-close"]], template: function FundChartMetricsListComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
        i0.ɵɵtext(2, "Financial Metrics");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(3, "div", 4)(4, "ycn-add-button-autocomplete", 5);
        i0.ɵɵlistener("submitHandler", function FundChartMetricsListComponent_Template_ycn_add_button_autocomplete_submitHandler_4_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.add($event)); });
        i0.ɵɵtext(5, "> ");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(6, "div", 6);
        i0.ɵɵelementStart(7, "div", 7)(8, "a", 8);
        i0.ɵɵlistener("click", function FundChartMetricsListComponent_Template_a_click_8_listener() { i0.ɵɵrestoreView(_r1); const multiMetricSelectorModal_r2 = i0.ɵɵreference(13); return i0.ɵɵresetView(multiMetricSelectorModal_r2.openModal()); });
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelement(9, "svg", 9);
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(10, "span");
        i0.ɵɵtext(11, "Browse");
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(12, "ycn-multi-metric-selector-modal", 10, 0);
        i0.ɵɵlistener("submitModalHandler", function FundChartMetricsListComponent_Template_ycn_multi_metric_selector_modal_submitModalHandler_12_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.addMetrics($event)); });
        i0.ɵɵelementEnd()()()();
        i0.ɵɵelementStart(14, "div", 11)(15, "div", 12, 1);
        i0.ɵɵconditionalCreate(17, FundChartMetricsListComponent_Conditional_17_Template, 1, 2, "ycn-skeleton-loaders-list", 13)(18, FundChartMetricsListComponent_Conditional_18_Template, 2, 0);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("appendToBody", true)("defaultOnly", ctx.defaultOnly);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("defaultOnly", ctx.defaultOnly);
        i0.ɵɵadvance(5);
        i0.ɵɵconditional(ctx.isLoading ? 17 : 18);
    } }, dependencies: [i3.AddButtonAutocompleteComponent, i4.IconDirective, i5.MultiMetricSelectorModalComponent, i6.SkeletonLoadersListComponent, i7.TooltipDirective], encapsulation: 2 });
